query getTopics {
  topics: getTopics {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
